import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
    CloseOutlined,
    CheckCircleOutlined,
    DragOutlined
} from '@ant-design/icons';

export default {
    getConference: async function (props, setFuncMap) {
        try {
            const res = await this.getConferenceByUidAction(props.conferenceUid)
            props.setContentHeader(res.data.name)
            setFuncMap.setIsPageLoading(false)
        } catch (error) {
        }
    },
    getConferenceByUidAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}`,
            headers: {
                "role": "topUser"
            }
        })
    },
    getAgendas: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getAgendasAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setAgendaMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getAgendasAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/agenda`,
            headers: {
                "role": "topUser"
            }
        })
    },
    updateAgenda: async function (payload, props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.updateAgendaAction(payload, props.conferenceUid)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    updateAgendaAction: (payload, conferenceUid) => {
        return axios({
            method: 'POST',
            url: `/conference/${conferenceUid}/agenda`,
            headers: {
                "role": "topUser"
            },
            data: payload
        })
    },
    getAgenda: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getAgendaByIdAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setAgendaMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getAgendaByIdAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/agenda`,
            headers: {
                "role": "topUser"
            }
        })
    },
};
